'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaffTakeoverMessage = require('./components/StaffTakeoverMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaffTakeoverMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-staff-takeover-message/lib/index.js
// module id = 1510
// module chunks = 1